import React from 'react'
import {
  GoogleTagManagerSeparator,
  GoogleTagManagerWrapperStyled,
} from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerWrapper/GoogleTagManagerWrapper.styled'
import { GoogleTagManagerManualMethod } from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerManual/GoogleTagManagerManualMethod'
import { GoogleTagManagerAuto } from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerAuto/GoogleTagManagerAuto'
import { Domain } from 'Types/Domain'
import { useSplit } from 'Hooks/useSplit'

type GoogleTagManagerWrapperProps = {
  tagUrl: string
  domain: Domain | undefined
}

export const GoogleTagManagerWrapper = ({ tagUrl, domain }: GoogleTagManagerWrapperProps) => {
  const showAutoGtmButton = useSplit('CE_GTM_AUTO')
  return (
    <GoogleTagManagerWrapperStyled>
      {showAutoGtmButton && (
        <>
          <GoogleTagManagerAuto domain={domain} />
          <GoogleTagManagerSeparator />
        </>
      )}
      <GoogleTagManagerManualMethod tagUrl={tagUrl} domainHashCode={domain?.tagHashCode || ''} />
    </GoogleTagManagerWrapperStyled>
  )
}
